import { Icon16Chevron } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type ReactElement, type ReactNode, type Ref, useEffect } from 'react';
import { EActions } from 'reactApp/modules/storage/storage.types';

import type { ListItem } from './DropdownList';
import styles from './DropdownList.css';

export interface DropdownListItemProps {
    item: ListItem;
    index: number;
    isLast: boolean;
    isOpen: boolean;
    itemClassName?: string;
    downloadRef?: Ref<HTMLDivElement>;
    onClick: (event: React.MouseEvent) => void;
    onMouseEnter: (event: React.MouseEvent) => void;
    onMouseLeave: () => void;
    onArrowClick: (event: React.MouseEvent) => void;
    onArrowMouseEnter: (event: React.MouseEvent) => void;
    onArrowMouseLeave: () => void;
    renderContent: (item: ListItem, index: number) => ReactElement | null;
    renderNested: () => ReactNode;
}

export const DropdownListItem = ({
    item,
    index,
    isLast,
    isOpen,
    itemClassName,
    downloadRef,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onArrowClick,
    onArrowMouseEnter,
    onArrowMouseLeave,
    renderContent,
    renderNested,
}: DropdownListItemProps): ReactElement => {
    useEffect(() => {
        item.onShow?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (item.render) {
        return <>{item.render()}</>;
    }

    return (
        <>
            <div
                className={classNames(styles.item, itemClassName, item.className, {
                    [styles.item_divider]: item.divider && !isLast,
                    [styles.item_selected]: item?.isSelected,
                    [styles.item_disabled]: item?.disabled,
                    [styles.item_aiPhotoGenerationPromo]: item.id === EActions.createAiPhotoGeneration,
                })}
                data-name={item.id}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                ref={item.id === 'download' ? downloadRef : undefined}
            >
                {renderContent(item, index)}
                {item.id === 'download' && <div id="promoContainer" />}
                {item.list && (
                    <div
                        className={classNames({
                            [styles.dropdownIcon]: true,
                            [styles.borderedArrow]: item.borderedArrow,
                        })}
                        onClick={onArrowClick}
                        onMouseEnter={onArrowMouseEnter}
                        onMouseLeave={onArrowMouseLeave}
                    >
                        <Icon16Chevron />
                    </div>
                )}
            </div>
            {item.list && isOpen && renderNested()}
        </>
    );
};
